import * as React from 'react'

import { Alert, Box, Button, CheckBox, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type { IExportScheduleFormValues } from 'modules/shift_management/lib/forms/ExportScheduleForm'

import { exportScheduleGroupByOptions } from './exportScheduleGroupByOptions'
import {
  useCreateExportSchedule,
  useExportScheduleForm,
  useShiftManagementHasConflifcts,
  useShiftManagementSelectedDateRange,
} from './useExportSchedule'

interface Props {
  onClose: () => void
}

const ExportScheduleModal = ({ onClose }: Props) => {
  const { startAt, endAt } = useShiftManagementSelectedDateRange()
  const shiftsHaveConflicts = useShiftManagementHasConflifcts()
  const { onSubmit, submitting } = useCreateExportSchedule(onClose)

  const form = useExportScheduleForm()
  const formValues = form.values as IExportScheduleFormValues

  const handleExcludeDraftsToggle = () => {
    form.setValues({
      exclude_drafts: !formValues.exclude_drafts,
    })
  }

  return (
    <Modal
      illustration="document-approved"
      title={i18n.t('shift_management.export_shifts.title')}
      description={i18n.t('shift_management.export_shifts.subheading', {
        startDate: startAt,
        endDate: endAt,
      })}
      onSubmit={() => onSubmit(formValues)}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={submitting} submit>
            {i18n.t('common.submit')}
          </Button>
        </>
      }
    >
      <Box gap="s24">
        <Select
          label={i18n.t('shift_management.export_shifts.form.export_by.label')}
          options={exportScheduleGroupByOptions()}
          field={form.get('export_by')}
        />
        <Box component="label" flexDirection="row" flexGrow gap="s8" alignItems="center">
          <CheckBox checked={formValues.exclude_drafts} onClick={handleExcludeDraftsToggle} />
          <Text size="200" weight="medium">
            {i18n.t('shift_management.export_shifts.form.exclude_draft_shifts.label')}
          </Text>
        </Box>

        {shiftsHaveConflicts && (
          <Box paddingBottom="s16">
            <Alert color="warning">
              {i18n.t('shift_management.export_shifts.form.conflicting_shifts_alert')}
            </Alert>
          </Box>
        )}
      </Box>
    </Modal>
  )
}

export default observer(ExportScheduleModal)
